module.exports = __webpack_public_path__ + "static/studio_04-3f93b17040adca92869d5f51bca220c5.jpg";